import { Component, h } from 'preact'
import Header from '../header'
import { PanelHeaderWithIcon } from '../registration-rules/PanelItems'
import axios from 'axios'
import AlertComponent from '../ui-components/AlertComponent'
import CreateEmailForm from './CreateEmailForm'
import CreateEmailPreview from './CreateEmailPreview'
import StatelessPanel from '../panel/StatelessPanel'

type Props = {
  emailCampaignId?: number,
  title?: string,
  subject?: string,
  content?: string,
  fromEmail?: string,
  fromUsername?: string,
  fromId?: number,
  status?: 'Draft' | 'Sent'
}

type State = {
  activePanel?: number,
  emailCampaignId: number | null,
  title: string,
  subject: string,
  content: string,
  alertMessage?: string,
  alertMessageType?: string,
  subjectError: string,
  showCreateEmailEdit: boolean,
  fromEmail: string,
  fromUsername: string,
  fromId: number,
  status: string
}

class EmailCampaignCreate extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      activePanel: 0,
      title: props.title || '',
      subject: props.subject || '',
      content: props.content || 'Hi,',
      subjectError: '',
      showCreateEmailEdit: false,
      fromEmail: props.fromEmail || window.inSidedData.user.email as string,
      fromUsername: props.fromUsername || window.inSidedData.user.name,
      fromId: props.fromId || parseInt(window.inSidedData.user.userid),
      status: props.status || 'Draft',
      emailCampaignId: props.emailCampaignId || null
    }

    this.onTitleChanged = this.onTitleChanged.bind(this)
    this.onSubjectChanged = this.onSubjectChanged.bind(this)
    this.onContentChanged = this.onContentChanged.bind(this)
    this.onSaveChanges = this.onSaveChanges.bind(this)
    this.hideAlertMessage = this.hideAlertMessage.bind(this)
    this.onPreviewClicked = this.onPreviewClicked.bind(this)
    this.onEmailCreateDone = this.onEmailCreateDone.bind(this)
  }

  onTitleChanged (title: string) {
    this.setState({ title })
  }

  onSubjectChanged (e: {target: HTMLInputElement}) {
    this.setState({ subject: e.target.value })
  }

  onContentChanged (content: string) {
    this.setState({ content })
  }

  onPreviewClicked () {
    this.setState({ showCreateEmailEdit: true })
  }

  onEmailCreateDone () {
    this.setState({ showCreateEmailEdit: false })
  }

  hideAlertMessage () {
    this.setState({
      alertMessageType: undefined,
      alertMessage: ''
    })
  }

  async onSaveChanges () {
    const { title, subject, content, fromEmail, fromUsername, fromId, emailCampaignId } = this.state

    if (subject === '') {
      this.setState({
        subjectError: 'Please enter a subject',
        showCreateEmailEdit: true
      })
      return
    } else {
      this.setState({ subjectError: '' })
    }

    try {
      await axios.post('/emailCampaign/save', {
        emailCampaignId: emailCampaignId || null,
        title: title || subject,
        subject,
        content,
        senderEmail: fromEmail,
        senderUsername: fromUsername,
        senderId: fromId
      }).then((res) => {
        this.setState({
          emailCampaignId: res.data.emailCampaignId,
          title: title || subject,
          alertMessageType: 'success'
        })
        window.history.pushState(null, '', `/email/email-campaign/${res.data.emailCampaignId}`)
      })
    } catch (e) {
      this.setState({
        alertMessageType: 'error'
      })
    }
  }

  render (_: Props, { activePanel, title, subject, content, alertMessage, alertMessageType, subjectError, showCreateEmailEdit, fromEmail, fromUsername, status }: State) {
    return <div className='create-email-campaign'>
      <Header
        title={title}
        disableCancelButton
        onTitleChanged={this.onTitleChanged}
        placeholder='Untitled Email Campaign'
        saveCallback={this.onSaveChanges}
        status={status}
        statusVariant={status === 'Draft' ? 'draft' : 'published'}
      />
      {alertMessageType && <AlertComponent
        messageType={alertMessageType}
        message={alertMessage}
        sticky
        isVisibleFor={5000}
        onTimeoutEnd={this.hideAlertMessage}
        onClose={this.hideAlertMessage}
      />}
      <StatelessPanel
        title={<PanelHeaderWithIcon
          customClass='panel-header-container'
          iconCustomClass='icon-panel-header'
          icon='editor'
          title='Create email'
        />}
        newStyle
      >
        { showCreateEmailEdit
          ? <CreateEmailForm
            subject={subject}
            onSubjectChanged={this.onSubjectChanged}
            subjectError={subjectError}
            content={content}
            onContentChanged={this.onContentChanged}
            onEmailCreateDone={this.onEmailCreateDone}
          />
          : <CreateEmailPreview
            subject={subject}
            content={content}
            fromUsername={fromUsername}
            fromEmail={fromEmail}
            onPreviewClicked={this.onPreviewClicked}
            onEmailCreateDone={this.onEmailCreateDone}
          />
        }
      </StatelessPanel>
    </div>
  }
}

export default EmailCampaignCreate
